import { useState, useEffect } from "react";
import { Form } from "antd";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UIElement from "../../Reusablecomponents/UIElement";
import Styled from "styled-components";

export const FormWrap = Styled.div`
  .ant-select { width: 100% !important; }
  .btn { border: none; padding: 10px 30px; width: 100%; }
  .ant-input { border-radius: 25px !important; }
`;

const GridBuilder = ({
  formStructureJson,
  handleChange,
  formSubmit,
  loading,
  handleClick,
  handleForgotPassword,
  handleSelectChange,
  initialValues = {},
  form,
  twoPerRowOnDesktop = false, // desktop layout
  twoPerRowInMobile = false, // mobile layout
  locationClick,
  onFenceCreate,
  onFenceEdit,
  isFenceEditMode = false,
  fenceLookupLoading = false,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValues]);

  const colStyle = { flex: "1" };

  return (
    <Form form={form} onFinish={formSubmit} initialValues={initialValues}>
      {formStructureJson.pages?.[0]?.fields?.map((row, rowIndex) => {
        const fieldsArray = row.flatMap((field) =>
          Array.isArray(field) ? field : [field]
        );

        // MOBILE VIEW
        if (isMobile) {
          if (twoPerRowInMobile) {
            // 2 fields per row on mobile
            const rowsForMobile = [];
            for (let i = 0; i < fieldsArray.length; i += 2) {
              const first = fieldsArray[i];
              const second = fieldsArray[i + 1];

              rowsForMobile.push(
                <Row key={i} className="mb-2">
                  <Col sm={6} className="newCol">
                    <FormWrap>
                      <UIElement
                        {...first}
                        handleChange={handleChange}
                        handleSelectChange={handleSelectChange}
                        loading={loading}
                        handleClick={() => handleClick()}
                        handleForgotPassword={handleForgotPassword}
                        form={form}
                        locationClick={locationClick}
                        initialValues={initialValues}
                        onFenceCreate={onFenceCreate}
                        onFenceEdit={onFenceEdit}
                        isFenceEditMode={isFenceEditMode}
                        fenceLookupLoading={fenceLookupLoading}
                      />
                    </FormWrap>
                  </Col>
                  {second && (
                    <Col sm={6} style={colStyle} className="newCol">
                      <FormWrap>
                        <UIElement
                          {...second}
                          handleChange={handleChange}
                          handleSelectChange={handleSelectChange}
                          loading={loading}
                          handleClick={() => handleClick()}
                          handleForgotPassword={handleForgotPassword}
                          form={form}
                          locationClick={locationClick}
                          initialValues={initialValues}
                          onFenceCreate={onFenceCreate}
                          onFenceEdit={onFenceEdit}
                          isFenceEditMode={isFenceEditMode}
                          fenceLookupLoading={fenceLookupLoading}
                        />
                      </FormWrap>
                    </Col>
                  )}
                </Row>
              );
            }
            return rowsForMobile;
          } else {
            // 1 field per row
            return fieldsArray.map((field) => (
              <Row key={field.id} className="mb-3">
                <Col sm={12} style={colStyle}>
                  <FormWrap>
                    <UIElement
                      {...field}
                      handleChange={handleChange}
                      handleSelectChange={handleSelectChange}
                      loading={loading}
                      handleClick={() => handleClick()}
                      handleForgotPassword={handleForgotPassword}
                      form={form}
                      locationClick={locationClick}
                      initialValues={initialValues}
                      onFenceCreate={onFenceCreate}
                      onFenceEdit={onFenceEdit}
                      isFenceEditMode={isFenceEditMode}
                      fenceLookupLoading={fenceLookupLoading}
                    />
                  </FormWrap>
                </Col>
              </Row>
            ));
          }
        }

        // DESKTOP VIEW: 2 fields per row
        if (twoPerRowOnDesktop) {
          const rowsForDesktop = [];
          for (let i = 0; i < fieldsArray.length; i += 2) {
            const first = fieldsArray[i];
            const second = fieldsArray[i + 1];
            rowsForDesktop.push(
              <Row key={i} className="mb-3">
                <Col sm={6} style={colStyle}>
                  <FormWrap>
                    <UIElement
                      {...first}
                      handleChange={handleChange}
                      handleSelectChange={handleSelectChange}
                      loading={loading}
                      handleClick={() => handleClick()}
                      handleForgotPassword={handleForgotPassword}
                      form={form}
                      locationClick={locationClick}
                      initialValues={initialValues}
                      onFenceCreate={onFenceCreate}
                      onFenceEdit={onFenceEdit}
                      isFenceEditMode={isFenceEditMode}
                      fenceLookupLoading={fenceLookupLoading}
                    />
                  </FormWrap>
                </Col>
                {second && (
                  <Col sm={6} style={colStyle}>
                    <FormWrap>
                      <UIElement
                        {...second}
                        handleChange={handleChange}
                        handleSelectChange={handleSelectChange}
                        loading={loading}
                        handleClick={() => handleClick()}
                        handleForgotPassword={handleForgotPassword}
                        form={form}
                        locationClick={locationClick}
                        initialValues={initialValues}
                        onFenceCreate={onFenceCreate}
                          onFenceEdit={onFenceEdit}
                          isFenceEditMode={isFenceEditMode}
                          fenceLookupLoading={fenceLookupLoading}
                      />
                    </FormWrap>
                  </Col>
                )}
              </Row>
            );
          }
          return rowsForDesktop;
        }

        // Default desktop layout using colSpan
        return (
          <Row key={rowIndex} gutter={16}>
            {fieldsArray.map((field, colIndex) => {
              const colSpan =
                formStructureJson.pages?.[0]?.colSpan?.[rowIndex]?.[colIndex] ||
                6;
              return (
                <Col key={field.id} sm={colSpan} style={colStyle}>
                  <FormWrap>
                    <UIElement
                      {...field}
                      handleChange={handleChange}
                      handleSelectChange={handleSelectChange}
                      loading={loading}
                      handleClick={() => handleClick()}
                      handleForgotPassword={handleForgotPassword}
                      locationClick={locationClick}
                      form={form}
                      initialValues={initialValues}
                      onFenceCreate={onFenceCreate}
                      onFenceEdit={onFenceEdit}
                      isFenceEditMode={isFenceEditMode}
                      fenceLookupLoading={fenceLookupLoading}
                    />
                  </FormWrap>
                </Col>
              );
            })}
          </Row>
        );
      })}
    </Form>
  );
};

export default GridBuilder;
